// extracted by mini-css-extract-plugin
export default {"container":"Xl-z","bubbleNav":"Yl-z","graphic":"Zl-z","contact":"_l-z"};